import React, { lazy, Suspense } from 'react';
import "moment/locale/es";
import { Routes, Route, Navigate } from 'react-router-dom';
import Loader from './components/Loader/Loader';
import "./sass/main.scss";
import { Toaster } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.min.css';

import { SecurityProvider } from './providers/SecurityProvider';
import { CategoriesProvider } from './providers/CategoriesProvider';
import PublicLayout from './components/layouts/PublicLayout/PublicLayout';
import { Protected } from './routes/guards/Protected';
import { PublicOnly } from './routes/guards/PublicOnly';
import { RequireRole } from './routes/guards/RequireRole';
import { RequirePermission } from './routes/guards/RequirePermission';
import { Role } from './assets/js/roles.js';
import { PAGO_STATUS } from './components/EstadoCompra/EstadoCompra';
//google ads
import GoogleAdsTracker from './components/GoogleAdsTracker/GoogleAdsTracker';

const Login = lazy(() => import('./pages/Login/Login'));
const AcceptInvitation = lazy(() => import('./pages/AcceptInvitation/AcceptInvitation'));
// const PruebaComponentes = lazy(() => import('./pages/PruebaComponentes/PruebaComponentes'));
const Home = lazy(() => import('./pages/Home/Home'));
const Contacto = lazy(() => import('./pages/Contacto/Contacto'));
const EstadoCompra = lazy(() => import('./components/EstadoCompra/EstadoCompra'));
const SobreNosotros = lazy(() => import('./pages/SobreNosotros/SobreNosotros'));
const CondicionesLegales = lazy(() => import('./pages/CondicionesLegales/CondicionesLegales'));
const CategoryEventsPage = lazy(() => import('./pages/CategoryEventsPage/CategoryEventsPage'));
const CategoryEventsRoutePage = lazy(() => import("./pages/CategoryEventsRoutePage/CategoryEventsRoutePage"));
const Registrarse = lazy(() => import('./pages/Login/Registrarse'));
const RecuperarContrasenia = lazy(() => import('./pages/Login/RecuperarContrasenia'));
const ResetPassword = lazy(() => import('./pages/Login/ResetPassword'));
const VerifyAccount = lazy(() => import('./pages/Login/VerifyAccount'));
const Usuario = lazy(() => import('./pages/Usuario/Usuario'));
const EventoDetalle = lazy(() => import('./pages/EventoDetalle/EventoDetalle'));
const Vender = lazy(() => import('./pages/Vender/Vender'));
const PasoSelecDia = lazy(() => import('./pages/Vender/pages/PasoSelecDia'));
const PasoDetallesPublicacion = lazy(() => import('./pages/Vender/pages/PasoDetallesPublicacion'));
const PasoPrecioCobro = lazy(() => import('./pages/Vender/pages/PasoPrecioCobro'));
const PasoPublicacionExitosa = lazy(() => import('./pages/Vender/pages/PasoPublicacionExitosa'));
const Abonos = lazy(() => import('./pages/Abonos/Abonos'));

// rutas backoffice
const BackOffice = lazy(() => import('./BackOffice/BackOffice'));
const RegistroArtista = lazy(() => import('./BackOffice/pages/RegistroArtista/RegistroArtista'));
const RegistroEvento = lazy(() => import('./BackOffice/pages/RegistroEvento/RegistroEvento'));
const RegistroRecinto = lazy(() => import('./BackOffice/pages/RegistroRecinto/RegistroRecinto'));
const Ventas = lazy(() => import('./BackOffice/pages/Ventas/Ventas'));
const Pagos = lazy(() => import('./BackOffice/pages/Pagos/Pagos'));
const Landing = lazy(() => import('./BackOffice/pages/Landing/Landing'));
const UsuarioBO = lazy(() => import('./BackOffice/pages/Usuario/Usuario'));
const FinanciamientoAdelantos = lazy(() => import('./BackOffice/pages/FinanciamientoAdelantos/FinanciamientoAdelantos'));
const PublicarEntradas = lazy(() => import('./BackOffice/pages/PublicarEntradas/PublicarEntradas'));
const PlansPage = lazy(() => import('./BackOffice/pages/PlansPage/PlansPage'))

// ruta backoffice clubes
const BackOfficeClubes = lazy(() => import('./BackOfficeClubes/BackOfficeClubes'));
const RegistroArtistaClub = lazy(() => import('./BackOfficeClubes/pages/RegistroArtista/RegistroArtista'));
const RegistroEventoClub = lazy(() => import('./BackOfficeClubes/pages/RegistroEvento/RegistroEvento'));
const PublicarEntradasClub = lazy(() => import('./BackOfficeClubes/pages/PublicarEntradas/PublicarEntradas'));
const VentasClub = lazy(() => import('./BackOfficeClubes/pages/Ventas/Ventas'));
const PagosClub = lazy(() => import('./BackOfficeClubes/pages/Pagos/Pagos'));
const FinanciamientoAdelantosClub = lazy(() => import('./BackOfficeClubes/pages/FinanciamientoAdelantos/FinanciamientoAdelantos'));
const TicketsCortesiaClub = lazy(() => import('./BackOfficeClubes/pages/TicketsCortesia/TicketsCortesia'));
const CortesiasProducer = lazy(() => import('./pages/Cortesias/CortesiasProducer'));
const CortesiasRecipient = lazy(() => import('./pages/Cortesias/CortesiasRecipient'));
const PlansPageClub = lazy(() => import('./BackOfficeClubes/pages/PlansPageClub/PlansPageClub'))

export default function App() {
  return (
    <SecurityProvider
      apiBaseURL={process.env.REACT_APP_TKTGO_FRONTEND_PUBLIC_URL}
      authBasePath="/auth"
      apiBasePath="/api-master/api"
    >
      <CategoriesProvider>
        <Suspense fallback={<Loader />}>
          <GoogleAdsTracker />
          <Routes>
            {/* Solo para no autenticados */}
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/registrarse" element={<PublicOnly><Registrarse /></PublicOnly>} />
            <Route path="/recuperar-contraseña" element={<PublicOnly><RecuperarContrasenia /></PublicOnly>} />
            <Route path="/password-reset/:hash" element={<PublicOnly><ResetPassword /></PublicOnly>} />
            <Route path="/verificar-cuenta/:hash" element={<PublicOnly><VerifyAccount /></PublicOnly>} />

            {/* Redireccion a home si se accede al raíz */}
            {/* <Route path="/" element={<Navigate to="/home" replace />} /> */}

            {/* Mostrar siempre (publico y privado) */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/sobre-nosotros" element={<SobreNosotros />} />
              <Route path="/condiciones-legales" element={<CondicionesLegales />} />
              <Route path="/abonos" element={<Abonos />} />
              <Route path="/:slug" element={<CategoryEventsRoutePage />} />
              <Route path="/todos" element={<CategoryEventsPage title="Todos los eventos" />} />
            </Route>
            <Route path="/courtesies/producer/:producer_token" element={<CortesiasProducer />} />
            <Route path="/courtesies/recipient/:recipient_token" element={<CortesiasRecipient />} />
            <Route path="/accept-invitation" element={<AcceptInvitation />} />
            {/* <Route path="/deportes" element={<CategoryEventsPage categoryId={1} title="Todos los Deportes" />} />
          <Route path="/conciertos" element={<CategoryEventsPage categoryId={2} title="Próximos Shows" />} />
          <Route path="/teatro" element={<CategoryEventsPage categoryId={3} title="Todas las Obras Teatrales" />} /> */}
            <Route path="/vender" element={
              <Protected>
                <RequirePermission permissions={["nitro4:ticket_sale_announcements:create"]} fallback={<Navigate to="/" replace />}>
                  <Vender />
                </RequirePermission>
              </Protected>} />
            <Route path="/eventos/:id" element={<EventoDetalle />} />
            <Route path="/failure/:sale_id" element={<EstadoCompra
              status={PAGO_STATUS.REJECTED}
              showSecondary={false}
              toPrimary="/usuario"
            />} />
            <Route path="/thankyou/:sale_id" element={<EstadoCompra
              status={PAGO_STATUS.SUCCESS}
              showSecondary={false}
              toPrimary="/usuario"
            />} />
            <Route path="/thankyou" element={<EstadoCompra
              status={PAGO_STATUS.SUCCESS}
              showSecondary={false}
              toPrimary="/usuario"
            />} />
            <Route path="/pending/:sale_id" element={<EstadoCompra
              status={PAGO_STATUS.PENDING}
              showSecondary={false}
              toPrimary="/usuario"
            />} />
            <Route path="/vender/:id" element={<PasoSelecDia />} />
            <Route path="/vender/detalles-publicacion" element={<PasoDetallesPublicacion />} />
            <Route path="/vender/precio-cobro" element={<PasoPrecioCobro />} />
            <Route path="/vender/publicacion" element={<PasoPublicacionExitosa />} />

            {/* Privadas solo para usuarios autenticados */}
            <Route path="/usuario" element={<Protected><Usuario /></Protected>} />

            {/* --- BackOffice  --- */}
            <Route path="/backoffice" element={<BackOffice />}>
              <Route index element={<Navigate to="registro/clubes" replace />} />
              <Route path="registro/clubes" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <RegistroArtista />
                  </RequireRole>
                </Protected>
              } />
              <Route path="registro/evento" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <RegistroEvento />
                  </RequireRole>
                </Protected>
              } />
              <Route path="planes-abono" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <PlansPage isClubAdminMode={true} showImports={true} />
                  </RequireRole>
                </Protected>
              } />
              <Route path="registro/recinto" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <RegistroRecinto />
                  </RequireRole>
                </Protected>
              } />
              <Route path="publicar-entradas" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <PublicarEntradas />
                  </RequireRole>
                </Protected>
              } />
              <Route path="ventas" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <Ventas />
                  </RequireRole>
                </Protected>
              } />
              <Route path="pagos" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <Pagos />
                  </RequireRole>
                </Protected>
              } />
              <Route path="landing" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <Landing />
                  </RequireRole>
                </Protected>
              } />
              <Route path="usuario" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <UsuarioBO />
                  </RequireRole>
                </Protected>
              } />
              <Route path="financiamientoAdelantos" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <FinanciamientoAdelantos />
                  </RequireRole>
                </Protected>
              } />
            </Route>


            {/* --- BackOffice Clubes  --- */}
            <Route path="/backoffice-clubes" element={<BackOfficeClubes />}>
              <Route index element={<Navigate to="registro/clubes" replace />} />
              <Route path="registro/clubes" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <RegistroArtistaClub />
                  </RequireRole>
                </Protected>
              } />
              <Route path="registro/evento" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <RegistroEventoClub />
                  </RequireRole>
                </Protected>
              } />
              {/* <Route path="prueba" element={
              <Protected>
                <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                  <PlansPage />
                </RequireRole>
              </Protected>
            } /> */}
              <Route path="publicar-entradas" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <PublicarEntradasClub />
                  </RequireRole>
                </Protected>
              } />
              <Route path="planes-abono" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <PlansPageClub />
                  </RequireRole>
                </Protected>
              } />
              <Route path="tickets-cortesia" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <TicketsCortesiaClub />
                  </RequireRole>
                </Protected>
              } />
              <Route path="ventas" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <VentasClub />
                  </RequireRole>
                </Protected>
              } />
              <Route path="pagos" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <PagosClub />
                  </RequireRole>
                </Protected>
              } />
              <Route path="financiamientoAdelantos" element={
                <Protected>
                  <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
                    <FinanciamientoAdelantosClub />
                  </RequireRole>
                </Protected>
              } />
            </Route>

            {/*
            Ejemplo de restriccion por permisos
            <Route
              path="/conciertos"
              element={
                <Protected>
                  <RequirePermission permissions={["nitro4:events:read"]} fallback={<Navigate to="/403" replace />}>
                    <Conciertos />
                  </RequirePermission>
                </Protected>
              }
              />

          Ejemplo de restriccion por roles
          <Route
            path="/deportes"
            element={
              <Protected>
                <RequireRole roles={["vendedor", "administrador"]} fallback={<Navigate to="/403" replace />}>
                  <Deportes />
                </RequireRole>
              </Protected>
            }
            />
          */}

          </Routes>
          <Toaster position="top-right" reverseOrder={false} />
        </Suspense>
      </CategoriesProvider>
    </SecurityProvider>
  );
}


















































// import React, { lazy, Suspense } from 'react';
// import "moment/locale/es";
// import { Routes, Route, Navigate } from 'react-router-dom';
// import Loader from './components/Loader/Loader';
// import "./sass/main.scss";
// import { Toaster } from 'react-hot-toast';
// import 'bootstrap/dist/css/bootstrap.min.css';

// import { SecurityProvider } from './providers/SecurityProvider';
// import { Protected } from './routes/guards/Protected';
// import { PublicOnly } from './routes/guards/PublicOnly';
// import { RequireRole } from './routes/guards/RequireRole';
// import { RequirePermission } from './routes/guards/RequirePermission';
// import { Role } from './assets/js/roles.js';
// import { PAGO_STATUS } from './components/EstadoCompra/EstadoCompra';
// //google ads
// import GoogleAdsTracker from './components/GoogleAdsTracker/GoogleAdsTracker';

// const Login = lazy(() => import('./pages/Login/Login'));
// const AcceptInvitation = lazy(() => import('./pages/AcceptInvitation/AcceptInvitation'));
// // const PruebaComponentes = lazy(() => import('./pages/PruebaComponentes/PruebaComponentes'));
// const Home = lazy(() => import('./pages/Home/Home'));
// const Contacto = lazy(() => import('./pages/Contacto/Contacto'));
// const EstadoCompra = lazy(() => import('./components/EstadoCompra/EstadoCompra'));
// const SobreNosotros = lazy(() => import('./pages/SobreNosotros/SobreNosotros'));
// const CondicionesLegales = lazy(() => import('./pages/CondicionesLegales/CondicionesLegales'));
// const CategoryEventsPage = lazy(() => import('./pages/CategoryEventsPage/CategoryEventsPage'));
// const CategoryEventsRoutePage = lazy(() => import("./pages/CategoryEventsRoutePage/CategoryEventsRoutePage"));
// const Registrarse = lazy(() => import('./pages/Login/Registrarse'));
// const RecuperarContrasenia = lazy(() => import('./pages/Login/RecuperarContrasenia'));
// const ResetPassword = lazy(() => import('./pages/Login/ResetPassword'));
// const VerifyAccount = lazy(() => import('./pages/Login/VerifyAccount'));
// const Usuario = lazy(() => import('./pages/Usuario/Usuario'));
// const EventoDetalle = lazy(() => import('./pages/EventoDetalle/EventoDetalle'));
// const Vender = lazy(() => import('./pages/Vender/Vender'));
// const PasoSelecDia = lazy(() => import('./pages/Vender/pages/PasoSelecDia'));
// const PasoDetallesPublicacion = lazy(() => import('./pages/Vender/pages/PasoDetallesPublicacion'));
// const PasoPrecioCobro = lazy(() => import('./pages/Vender/pages/PasoPrecioCobro'));
// const PasoPublicacionExitosa = lazy(() => import('./pages/Vender/pages/PasoPublicacionExitosa'));
// const Abonos = lazy(() => import('./pages/Abonos/Abonos'));

// // rutas backoffice
// const BackOffice = lazy(() => import('./BackOffice/BackOffice'));
// const RegistroArtista = lazy(() => import('./BackOffice/pages/RegistroArtista/RegistroArtista'));
// const RegistroEvento = lazy(() => import('./BackOffice/pages/RegistroEvento/RegistroEvento'));
// const RegistroRecinto = lazy(() => import('./BackOffice/pages/RegistroRecinto/RegistroRecinto'));
// const Ventas = lazy(() => import('./BackOffice/pages/Ventas/Ventas'));
// const Pagos = lazy(() => import('./BackOffice/pages/Pagos/Pagos'));
// const Landing = lazy(() => import('./BackOffice/pages/Landing/Landing'));
// const UsuarioBO = lazy(() => import('./BackOffice/pages/Usuario/Usuario'));
// const FinanciamientoAdelantos = lazy(() => import('./BackOffice/pages/FinanciamientoAdelantos/FinanciamientoAdelantos'));
// const PublicarEntradas = lazy(() => import('./BackOffice/pages/PublicarEntradas/PublicarEntradas'));
// const PlansPage = lazy(() => import('./BackOffice/pages/PlansPage/PlansPage'))

// // ruta backoffice clubes
// const BackOfficeClubes = lazy(() => import('./BackOfficeClubes/BackOfficeClubes'));
// const RegistroArtistaClub = lazy(() => import('./BackOfficeClubes/pages/RegistroArtista/RegistroArtista'));
// const RegistroEventoClub = lazy(() => import('./BackOfficeClubes/pages/RegistroEvento/RegistroEvento'));
// const PublicarEntradasClub = lazy(() => import('./BackOfficeClubes/pages/PublicarEntradas/PublicarEntradas'));
// const VentasClub = lazy(() => import('./BackOfficeClubes/pages/Ventas/Ventas'));
// const PagosClub = lazy(() => import('./BackOfficeClubes/pages/Pagos/Pagos'));
// const FinanciamientoAdelantosClub = lazy(() => import('./BackOfficeClubes/pages/FinanciamientoAdelantos/FinanciamientoAdelantos'));
// const TicketsCortesiaClub = lazy(() => import('./BackOfficeClubes/pages/TicketsCortesia/TicketsCortesia'));
// const CortesiasProducer = lazy(() => import('./pages/Cortesias/CortesiasProducer'));
// const CortesiasRecipient = lazy(() => import('./pages/Cortesias/CortesiasRecipient'));
// const PlansPageClub = lazy(() => import('./BackOfficeClubes/pages/PlansPageClub/PlansPageClub'))

// export default function App() {
//   return (
//     <SecurityProvider
//       apiBaseURL={process.env.REACT_APP_TKTGO_FRONTEND_PUBLIC_URL}
//       authBasePath="/auth"
//       apiBasePath="/api-master/api"
//     >
//       <Suspense fallback={<Loader />}>
//         <GoogleAdsTracker />
//         <Routes>
//           {/* Solo para no autenticados */}
//           <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
//           <Route path="/registrarse" element={<PublicOnly><Registrarse /></PublicOnly>} />
//           <Route path="/recuperar-contraseña" element={<PublicOnly><RecuperarContrasenia /></PublicOnly>} />
//           <Route path="/password-reset/:hash" element={<PublicOnly><ResetPassword /></PublicOnly>} />
//           <Route path="/verificar-cuenta/:hash" element={<PublicOnly><VerifyAccount /></PublicOnly>} />

//           {/* Redireccion a home si se accede al raíz */}
//           {/* <Route path="/" element={<Navigate to="/home" replace />} /> */}

//           {/* Mostrar siempre (publico y privado) */}
//           <Route path="/" element={<Home />} />
//           <Route path="/contacto" element={<Contacto />} />
//           <Route path="/sobre-nosotros" element={<SobreNosotros />} />
//           <Route path="/condiciones-legales" element={<CondicionesLegales />} />
//           <Route path="/courtesies/producer/:producer_token" element={<CortesiasProducer />} />
//           <Route path="/courtesies/recipient/:recipient_token" element={<CortesiasRecipient />} />
//           <Route path="/abonos" element={<Abonos />} />
//           <Route path="/:slug" element={<CategoryEventsRoutePage />} />
//           <Route path="/todos" element={<CategoryEventsPage title="Todos los eventos" />} />
//           <Route path="/accept-invitation" element={<AcceptInvitation />} />
//           {/* <Route path="/deportes" element={<CategoryEventsPage categoryId={1} title="Todos los Deportes" />} />
//           <Route path="/conciertos" element={<CategoryEventsPage categoryId={2} title="Próximos Shows" />} />
//           <Route path="/teatro" element={<CategoryEventsPage categoryId={3} title="Todas las Obras Teatrales" />} /> */}
//           <Route path="/vender" element={
//             <Protected>
//               <RequirePermission permissions={["nitro4:ticket_sale_announcements:create"]} fallback={<Navigate to="/" replace />}>
//                 <Vender />
//               </RequirePermission>
//             </Protected>} />
//           <Route path="/eventos/:id" element={<EventoDetalle />} />
//           <Route path="/failure/:sale_id" element={<EstadoCompra
//             status={PAGO_STATUS.REJECTED}
//             showSecondary={false}
//             toPrimary="/usuario"
//           />} />
//           <Route path="/thankyou/:sale_id" element={<EstadoCompra
//             status={PAGO_STATUS.SUCCESS}
//             showSecondary={false}
//             toPrimary="/usuario"
//           />} />
//           <Route path="/thankyou" element={<EstadoCompra
//             status={PAGO_STATUS.SUCCESS}
//             showSecondary={false}
//             toPrimary="/usuario"
//           />} />
//           <Route path="/pending/:sale_id" element={<EstadoCompra
//             status={PAGO_STATUS.PENDING}
//             showSecondary={false}
//             toPrimary="/usuario"
//           />} />
//           <Route path="/vender/:id" element={<PasoSelecDia />} />
//           <Route path="/vender/detalles-publicacion" element={<PasoDetallesPublicacion />} />
//           <Route path="/vender/precio-cobro" element={<PasoPrecioCobro />} />
//           <Route path="/vender/publicacion" element={<PasoPublicacionExitosa />} />

//           {/* Privadas solo para usuarios autenticados */}
//           <Route path="/usuario" element={<Protected><Usuario /></Protected>} />

//           {/* --- BackOffice  --- */}
//           <Route path="/backoffice" element={<BackOffice />}>
//             <Route index element={<Navigate to="registro/clubes" replace />} />
//             <Route path="registro/clubes" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <RegistroArtista />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="registro/evento" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <RegistroEvento />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="planes-abono" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <PlansPage isClubAdminMode={true} showImports={true} />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="registro/recinto" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <RegistroRecinto />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="publicar-entradas" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <PublicarEntradas />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="ventas" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <Ventas />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="pagos" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <Pagos />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="landing" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <Landing />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="usuario" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <UsuarioBO />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="financiamientoAdelantos" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <FinanciamientoAdelantos />
//                 </RequireRole>
//               </Protected>
//             } />
//           </Route>


//           {/* --- BackOffice Clubes  --- */}
//           <Route path="/backoffice-clubes" element={<BackOfficeClubes />}>
//             <Route index element={<Navigate to="registro/clubes" replace />} />
//             <Route path="registro/clubes" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <RegistroArtistaClub />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="registro/evento" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <RegistroEventoClub />
//                 </RequireRole>
//               </Protected>
//             } />
//             {/* <Route path="prueba" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <PlansPage />
//                 </RequireRole>
//               </Protected>
//             } /> */}
//             <Route path="publicar-entradas" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <PublicarEntradasClub />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="planes-abono" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <PlansPageClub />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="tickets-cortesia" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <TicketsCortesiaClub />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="ventas" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <VentasClub />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="pagos" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <PagosClub />
//                 </RequireRole>
//               </Protected>
//             } />
//             <Route path="financiamientoAdelantos" element={
//               <Protected>
//                 <RequireRole roles={[Role?.ADMIN, Role?.CLUB_ADMIN]} fallback={<Navigate to="/login" replace />}>
//                   <FinanciamientoAdelantosClub />
//                 </RequireRole>
//               </Protected>
//             } />
//           </Route>

//           {/*
//             Ejemplo de restriccion por permisos
//             <Route
//               path="/conciertos"
//               element={
//                 <Protected>
//                   <RequirePermission permissions={["nitro4:events:read"]} fallback={<Navigate to="/403" replace />}>
//                     <Conciertos />
//                   </RequirePermission>
//                 </Protected>
//               }
//               />

//           Ejemplo de restriccion por roles
//           <Route
//             path="/deportes"
//             element={
//               <Protected>
//                 <RequireRole roles={["vendedor", "administrador"]} fallback={<Navigate to="/403" replace />}>
//                   <Deportes />
//                 </RequireRole>
//               </Protected>
//             }
//             />
//           */}

//         </Routes>
//         <Toaster position="top-right" reverseOrder={false} />
//       </Suspense>
//     </SecurityProvider>
//   );
// }